import MetalIImage from "@/images/metal_i@2x.png";
import MetalJImage from "@/images/metal_j@2x.png";
import MetalKImage from "@/images/metal_k@2x.png";

export default [
  {
    shape: "桃心",
    name: "桃心雙龍",
    code: "I",
    imagePath: MetalIImage,
    accessory: [1, 2, 3, 4],
    way: ["A", "B", "C"],
    textSetting: {
      templeName: {
        lineLimit: 2,
        textLimit: 6,
        maxFontsize: 25,
      },
      godName: {
        lineLimit: 2,
        textLimit: 10,
        maxFontsize: 55,
      },
      gift: {
        lineLimit: 2,
        textLimit: 8,
        maxFontsize: 20,
      },
    },
    engravingContentType: "default",
  },
  {
    shape: "桃心",
    name: "桃心五福",
    code: "J",
    imagePath: MetalJImage,
    accessory: [1, 2, 3, 4],
    way: ["A", "B", "C"],
    textSetting: {
      templeName: {
        lineLimit: 2,
        textLimit: 5,
        maxFontsize: 25,
      },
      godName: {
        lineLimit: 1,
        textLimit: 10,
        maxFontsize: 55,
      },
      gift: {
        lineLimit: 2,
        textLimit: 5,
        maxFontsize: 20,
      },
    },
    engravingContentType: "default",
  },
  {
    shape: "桃心",
    name: "桃心福全",
    code: "K",
    imagePath: MetalKImage,
    accessory: [1, 2, 3, 4],
    way: ["A", "B", "C"],
    textSetting: {
      templeName: {
        lineLimit: 1,
        textLimit: 10,
        maxFontsize: 25,
      },
      godName: {
        lineLimit: 2,
        textLimit: 10,
        maxFontsize: 55,
      },
      gift: {
        lineLimit: 2,
        textLimit: 12,
        maxFontsize: 20,
      },
    },
    engravingContentType: "default",
  },
];
